import { render, staticRenderFns } from "./AcademyView.vue?vue&type=template&id=7753b8be&"
import script from "./AcademyView.vue?vue&type=script&lang=js&"
export * from "./AcademyView.vue?vue&type=script&lang=js&"
import style0 from "./AcademyView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports